/* ============================================================================
   kylymky-landing.js — grow-some
   Configurator logic for /pages/kylymky (sections/kylymky-landing.liquid).
   Extracted verbatim from the section inline <script> for browser caching.
   Contains NO Liquid; merchant/OOS values are read from DOM data-* attributes.
   Loaded with defer. Keeps window.kl* exposure used by inline onclick= handlers.
   ============================================================================ */
(function(){

/* ---------- Config ---------- */
var SIZES = [
  {qty:3,  vid:'40917542731819', price:180,  freeShip:false},
  {qty:6,  vid:'40017909055531', price:299,  freeShip:false},
  {qty:12, vid:'40017999167531', price:599,  freeShip:false},
  {qty:24, vid:'40869711511595', price:936,  freeShip:false},
  {qty:36, vid:'40017999921195', price:1519, freeShip:true}
];

var CDN = 'https://cdn.shopify.com/s/files/1/0568/2688/8235/files/';

var MATS = [
  {id:'brokoli', name:'Броколі',         img: CDN+'grow-some-seedpad-broccoli.webp?v=1777217511',    org:false, benefit:'100x більше сульфорафану — виводить токсини, знижує запалення'},
  {id:'kapusta', name:'Капуста червона', img: CDN+'grow-some-seedpad-red-cabbage.webp?v=1777217511', org:false, benefit:'40x більше вітаміну E — антоціани захищають клітини від старіння'},
  {id:'morkva',  name:'Морква',          img: CDN+'grow-some-seedpad-carrot.webp?v=1777217511',      org:false, benefit:'Бета-каротин і лютеїн — здоров\'я очей і шкіри'},
  {id:'shchek',  name:'Щекавиця (мікс)', img: CDN+'grow-some-seedpad-shekavysya.webp?v=1777218120',  org:false, benefit:'4 в 1: сульфорафан + вітамін C + антоціани + ізотіоціанати'},
  {id:'lyuts',   name:'Люцерна',         img: CDN+'grow-some-seedpad-alfalfa.webp?v=1777217510',     org:true,  benefit:'Кальцій + магній + фітоестрогени — гормональний баланс'},
  {id:'sonyakh', name:'Сонях',           img: CDN+'grow-some-seedpad-sunflower.webp?v=1777217511',   org:true,  benefit:'Топ-1 за цинком серед мікрозелені + 8 незамінних амінокислот'},
  {id:'redys',   name:'Редис',           img: CDN+'grow-some-seedpad-radish.webp?v=1777217511',      org:false, benefit:'95 мг вітаміну C на 100г — більше ніж у апельсині'},
  {id:'gorox',   name:'Горох вусатий',   img: CDN+'grow-some-seedpad-pea.webp?v=1777217511',         org:false, benefit:'66% добової норми вітаміну C в одній жмені'},
  {id:'girch',   name:'Гірчиця',         img: CDN+'grow-some-seedpad-mustard.webp?v=1777217511',     org:true,  benefit:'Топ-1 за вітаміном C серед капустяних + антимікробна дія'},
  {id:'kony',    name:'Конюшина',        img: CDN+'grow-some-seedpad-clover.webp?v=1777218120',      org:true,  benefit:'Ізофлавони — підтримка серцево-судинної системи'},
  {id:'koty',    name:'Трава котикам',   img: CDN+'grow-some-seedpad-catgrass.webp?v=1777217511',    org:true,  benefit:'Виводить кульки шерсті + покращує травлення котиків'},
  {id:'gorox2',  name:'Горох дикий',     img: CDN+'grow-some-seedpad-wild-pea.webp?v=1777217511',    org:true,  benefit:'Вітаміни A, C, E і фолієва кислота в одній порції'},
  {id:'bazylik', name:'Базилік',         img: CDN+'grow-some-seedpad-basil.webp?v=1777217511',       org:false, soon:true, benefit:'Ароматний, багатий на кальцій — для міцних кісток та імунітету'},
  {id:'rukola',  name:'Рукола',          img: CDN+'grow-some-seedpad-arugula.webp?v=1783371281',     org:false, benefit:'Пікантна, з вітаміном K і кальцієм — корисна для кісток'},
  {id:'kres',    name:'Крес',            img: CDN+'grow-some-seedpad-cress-salad.webp?v=1783370687', org:false, benefit:'Гострий смак і багато вітаміну C — для бадьорості й імунітету'},
  {id:'mash',    name:'Маш',             img: CDN+'grow-some-seedpad-mash.webp?v=1779042922',        org:false, benefit:'Ніжний смак, вітаміни групи B і залізо — додають енергії'}
];

// POTS будуються з DOM-карток #kl-pot-{key}: варіант/ціна/назва приходять із товару
// через data-* (Liquid), а не хардкодяться. Картка може бути відсутня (товар не заданий).
var POTS = {};
['std', 'cer', 'dbl'].forEach(function (key) {
  var card = document.getElementById('kl-pot-' + key);
  if (!card) return;
  var nameEl = card.querySelector('.kl-pot-name');
  POTS[key] = {
    vid: card.dataset.vid || '',
    price: parseInt(card.dataset.price, 10) || 0,
    name: nameEl ? nameEl.textContent.trim() : key
  };
});

var OOS = [];
/* Килимки з soon:true (тимчасово немає в наявності) — обираються не можна,
   лише бейдж-попередження на картці. Окремий список від OOS вище, щоб не
   зачіпати старий "Немає" оверлей/затемнення — тут своя, легша візуалізація. */
var SOON_IDS = MATS.filter(function(m){ return m.soon; }).map(function(m){ return m.id; });
var STORAGE_KEY = 'kl_state_v6';

/* ---------- State ---------- */
var selectedSize = null;
var matQtys = {};
MATS.forEach(function(m){ matQtys[m.id] = 0; });
var potQtys = {};
Object.keys(POTS).forEach(function (k) { potQtys[k] = 0; });

/* ---------- Persistence ---------- */
function saveState(){
  try{
    localStorage.setItem(STORAGE_KEY, JSON.stringify({
      sizeQty: selectedSize ? selectedSize.qty : null,
      matQtys: matQtys,
      potQtys: potQtys,
      savedAt: Date.now()
    }));
  }catch(e){}
}

function loadState(){
  try{
    var raw = localStorage.getItem(STORAGE_KEY);
    if(!raw) return;
    var data = JSON.parse(raw);
    if(Date.now() - data.savedAt > 172800000){ localStorage.removeItem(STORAGE_KEY); return; }
    if(data.matQtys) Object.keys(data.matQtys).forEach(function(k){ if(k in matQtys) matQtys[k] = data.matQtys[k]; });
    if(data.potQtys) Object.keys(data.potQtys).forEach(function(k){ if(k in potQtys) potQtys[k] = data.potQtys[k]; });
    if(data.sizeQty){
      selectedSize = SIZES.find(function(s){ return s.qty === data.sizeQty; });
      if(selectedSize){
        document.querySelectorAll('.kl-size-btn').forEach(function(b){
          if(parseInt(b.dataset.size) === data.sizeQty) b.classList.add('sel');
        });
        var fs = document.getElementById('kl-free-ship');
        fs.style.display = selectedSize.freeShip ? '' : 'none';
        /* clamp mats to limit (на випадок зміни ліміту) */
        var sum = matTot();
        if(sum > selectedSize.qty){
          MATS.forEach(function(m){ matQtys[m.id] = 0; });
        }
      }
    }
    /* Стара кількість soon-килимка, збережена ДО того як він став тимчасово
       недоступним, — обнуляємо, щоб localStorage не обходив блокування. */
    SOON_IDS.forEach(function(id){ matQtys[id] = 0; });
    MATS.forEach(function(m){
      var inp = document.getElementById('klmi-' + m.id);
      if(inp) inp.value = matQtys[m.id] || 0;
    });
  }catch(e){}
}

/* ---------- Helpers ---------- */
function decKyl(n){
  var a = Math.abs(n) % 100, r = a % 10;
  if(a >= 11 && a <= 19) return 'килимків';
  if(r === 1) return 'килимок';
  if(r >= 2 && r <= 4) return 'килимки';
  return 'килимків';
}
function fmt(n){
  return n.toLocaleString('uk-UA', {minimumFractionDigits:0, maximumFractionDigits:0}) + ' грн';
}
function matTot(){
  return Object.values(matQtys).reduce(function(a,b){ return a+b; }, 0);
}
function potCost(){
  return Object.keys(potQtys).reduce(function(s,k){ return s + POTS[k].price * potQtys[k]; }, 0);
}
function limit(){ return selectedSize ? selectedSize.qty : 0; }
function spaceLeft(){ return limit() - matTot(); }

/* ---------- Build mat grid ---------- */
var grid = document.getElementById('kl-mat-grid');
var minusSVG = '<svg viewBox="0 0 14 14" aria-hidden="true"><rect x="0" y="6" width="14" height="2" fill="currentColor"/></svg>';
var plusSVG  = '<svg viewBox="0 0 14 14" aria-hidden="true"><rect x="0" y="6" width="14" height="2" fill="currentColor"/><rect x="6" y="0" width="2" height="14" fill="currentColor"/></svg>';

MATS.forEach(function(m){
  var oos = OOS.indexOf(m.id) !== -1;
  var div = document.createElement('div');
  div.className = 'kl-mat-card' + (oos ? ' oos' : '');
  div.dataset.id = m.id;
  div.dataset.name = m.name;

  /* Responsive variants via Shopify CDN &width= (m.img already carries ?v=...), so phones
     fetch ~200px thumbnails instead of full-res webp. Container reserves space (no CLS). */
  var imgHtml = m.img
    ? '<img src="' + m.img + '&width=200"'
      + ' srcset="' + m.img + '&width=120 120w, ' + m.img + '&width=200 200w, ' + m.img + '&width=300 300w"'
      + ' sizes="(max-width:600px) 45vw, (max-width:900px) 30vw, 22vw"'
      + ' alt="' + m.name + '" loading="lazy">'
    : '<span style="font-size:32px">&#127808;</span>';

  div.innerHTML =
    '<div class="kl-mat-img-wrap">' +
      '<div class="kl-mat-badge" id="klb-' + m.id + '">0</div>' +
      '<div class="kl-mat-img">' + imgHtml + '</div>' +
      (m.soon ? '<div class="kl-mat-soon">Поки не в наявності</div>' : '') +
      '<div class="kl-oos-ov">Немає</div>' +
    '</div>' +
    '<div class="kl-mat-body">' +
      '<p class="kl-mat-name">' + m.name + (m.org ? ' &#127808;' : '') + '</p>' +
      '<p class="kl-mat-benefit">' + m.benefit + '</p>' +
    '</div>' +
    '<div class="kl-mat-cnt-wrap">' +
      '<div class="kl-mat-cnt">' +
        '<button class="kl-mc-btn" id="klmm-' + m.id + '" type="button" onclick="klMatChange(\'' + m.id + '\',-1)" aria-label="Зменшити" disabled>' + minusSVG + '</button>' +
        '<input class="kl-mc-input" id="klmi-' + m.id + '" type="number" value="0" min="0"' +
          (m.soon ? ' readonly' : '') +
          ' oninput="klMatInput(\'' + m.id + '\',this.value)"' +
          ' onblur="klMatInput(\'' + m.id + '\',this.value,true)"' +
          ' onfocus="this.select()">' +
        '<button class="kl-mc-btn" id="klmp-' + m.id + '" type="button" onclick="klMatChange(\'' + m.id + '\',1)" aria-label="Збільшити"' + (m.soon ? ' disabled' : '') + '>' + plusSVG + '</button>' +
      '</div>' +
    '</div>';
  grid.appendChild(div);
});

var matCards = Array.from(grid.querySelectorAll('.kl-mat-card'));

/* ---------- Mats logic (NO UPSELL — hard limit) ---------- */
window.klSelectSize = function(btn){
  document.querySelectorAll('.kl-size-btn').forEach(function(b){ b.classList.remove('sel'); });
  btn.classList.add('sel');
  selectedSize = SIZES.find(function(s){ return s.qty === parseInt(btn.dataset.size); });
  var fs = document.getElementById('kl-free-ship');
  fs.style.display = selectedSize.freeShip ? '' : 'none';
  /* якщо новий ліміт менший за поточну кількість — скидаємо рослини */
  if(matTot() > selectedSize.qty){
    MATS.forEach(function(m){
      matQtys[m.id] = 0;
      var inp = document.getElementById('klmi-' + m.id);
      if(inp) inp.value = 0;
    });
  }
  renderMats();
  renderSummary();
};

window.klMatChange = function(id, delta){
  if(SOON_IDS.indexOf(id) !== -1) return;
  if(!selectedSize){
    var firstSize = document.querySelector('.kl-size-btn');
    if(firstSize){
      firstSize.scrollIntoView({behavior:'smooth', block:'center'});
      firstSize.animate(
        [{boxShadow:'0 0 0 0 rgba(41,172,86,0)'},{boxShadow:'0 0 0 4px rgba(41,172,86,.35)'},{boxShadow:'0 0 0 0 rgba(41,172,86,0)'}],
        {duration:900}
      );
    }
    return;
  }
  var cur = matQtys[id] || 0;
  var nv  = cur + delta;
  if(nv < 0) return;
  /* hard limit */
  if(delta > 0 && matTot() >= limit()) return;
  if(nv > cur + spaceLeft()) nv = cur + spaceLeft();
  matQtys[id] = nv;
  var inp = document.getElementById('klmi-' + id);
  if(inp) inp.value = nv;
  renderMats();
  renderSummary();
};

window.klMatInput = function(id, val, isBlur){
  if(SOON_IDS.indexOf(id) !== -1) return;
  if(!selectedSize) return;
  var nv = parseInt(val);
  if(isNaN(nv) || nv < 0) nv = 0;
  /* max = ліміт - сума інших килимків (без цього) */
  var sumOthers = 0;
  MATS.forEach(function(m){ if(m.id !== id) sumOthers += matQtys[m.id] || 0; });
  var max = limit() - sumOthers;
  if(nv > max) nv = max;
  matQtys[id] = nv;
  /* НЕ оновлюємо inp.value поки користувач друкує — інакше курсор стрибає.
     Клемпимо візуально тільки на blur, або коли значення треба обрізати. */
  if(isBlur){
    var inp = document.getElementById('klmi-' + id);
    if(inp && parseInt(inp.value) !== nv) inp.value = nv;
  }
  renderMats();
  renderSummary();
};

function renderMats(){
  var tot = matTot();
  var lim = limit();
  var ctr = document.getElementById('kl-counter');
  if(lim > 0){
    ctr.style.display = '';
    document.getElementById('kl-counter-val').textContent = tot;
    document.getElementById('kl-counter-lim').textContent = lim;
    ctr.classList.toggle('full', tot === lim);
  }else{
    ctr.style.display = 'none';
  }
  var atLimit = (tot >= lim && lim > 0);

  matCards.forEach(function(card){
    var id    = card.dataset.id;
    var q     = matQtys[id] || 0;
    var oos   = card.classList.contains('oos') || SOON_IDS.indexOf(id) !== -1;
    var badge = document.getElementById('klb-' + id);
    var minus = document.getElementById('klmm-' + id);
    var plus  = document.getElementById('klmp-' + id);

    card.classList.toggle('sel', q > 0);
    if(badge) badge.textContent = q;
    if(minus) minus.disabled = (q === 0 || oos);
    /* plus disabled при ліміті, навіть для уже доданих рослин */
    if(plus)  plus.disabled  = (oos || atLimit);
  });
}

/* ---------- Pots logic ---------- */
window.klTogglePot = function(id){
  if(potQtys[id] === 0) klChangePot(id, 1);
};
window.klChangePot = function(id, delta){
  var nv = potQtys[id] + delta;
  if(nv < 0 || nv > 2) return;
  potQtys[id] = nv;
  renderPots();
  renderSummary();
};
function renderPots(){
  ['std','cer','dbl'].forEach(function(k){
    var q    = potQtys[k];
    var card = document.getElementById('kl-pot-' + k);
    var val  = document.getElementById('kl-p' + k + '-v');
    var min  = document.getElementById('kl-p' + k + '-m');
    if(card) card.classList.toggle('sel', q > 0);
    if(val)  val.value = q;
    if(min)  min.disabled = (q === 0);
  });
}

/* ---------- Summary ---------- */
function renderSummary(){
  var tot   = matTot();
  var lim   = limit();
  var pCost = potCost();
  var total = (selectedSize ? selectedSize.price : 0) + pCost;

  var chosen = matCards.filter(function(c){ return (matQtys[c.dataset.id] || 0) > 0; });
  var pillsEl = document.getElementById('kl-pills');
  if(chosen.length > 0){
    pillsEl.innerHTML = chosen.map(function(c){
      var q = matQtys[c.dataset.id];
      return '<span class="kl-pill">' + c.dataset.name + (q > 1 ? ' x' + q : '') + '</span>';
    }).join('');
  }else{
    pillsEl.innerHTML = '<span class="kl-no-pills">Оберіть розмір і рослини</span>';
  }

  document.getElementById('kl-total').textContent = selectedSize ? fmt(total) : '—';

  var cta   = document.getElementById('kl-cta');
  var cta2  = document.getElementById('kl-cta-2');
  var hint2 = document.getElementById('kl-hint-2');
  var txt, dis;

  if(!selectedSize){
    txt = 'Оберіть розмір і рослини'; dis = true;
  }else if(tot === 0){
    txt = 'Оберіть рослини'; dis = true;
  }else if(tot < lim){
    var need = lim - tot;
    txt = 'Оберіть ще ' + need + ' ' + decKyl(need); dis = true;
  }else{
    txt = 'Додати до кошика — ' + fmt(total); dis = false;
  }

  cta.disabled  = dis; cta.textContent  = txt;
  cta2.disabled = dis; cta2.textContent = txt;
  hint2.textContent = dis ? '' : 'Готово до замовлення';

  document.getElementById('kl-err-inline').classList.remove('show');
  renderPots();
  saveState();
}

/* ---------- Toast helper ---------- */
function klShowToast(msg, isErr){
  var t = document.getElementById('kl-toast');
  document.getElementById('kl-toast-msg').textContent = msg;
  t.style.background = isErr ? '#FDECEC' : '#E9F5EC';
  t.style.borderColor = isErr ? '#F0C2C2' : '#B8DBC0';
  t.style.color      = isErr ? '#7A1A1A' : '#1F5028';
  t.classList.add('show');
  if(!isErr) setTimeout(function(){ t.classList.remove('show'); }, 4000);
}

/* ---------- Add to cart ---------- */
function klPostOne(item){
  console.log('[kl] POST cart/add', item);
  return fetch(window.Shopify.routes.root + 'cart/add.js', {
    method:  'POST',
    headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
    body:    JSON.stringify({items: [item]})
  }).then(function(r){
    console.log('[kl] response status:', r.status);
    return r.text().then(function(txt){
      var data; try { data = JSON.parse(txt); } catch(e){ data = null; }
      if(!r.ok){
        var msg = (data && (data.description || data.message)) || ('HTTP ' + r.status);
        console.error('[kl] cart/add failed:', r.status, txt);
        var e = new Error(msg);
        e.variantId = item.id;
        throw e;
      }
      return data;
    });
  });
}

function klSync(){
  /* Sync-point: чекаємо щоб Shopify закомітив зміни кошика перед наступним запитом */
  return fetch(window.Shopify.routes.root + 'cart.js', {cache:'no-store'})
    .then(function(r){ return r.json(); });
}

/* Open the site cart drawer with fresh contents (Section Rendering API), matching the
   rest of the theme. Falls back to /cart if no <cart-drawer> is present (e.g. cart=page). */
function klOpenDrawer(){
  var drawer = document.querySelector('cart-drawer');
  if(!drawer || typeof drawer.renderContents !== 'function'){
    window.location.href = '/cart';
    return;
  }
  var ids = drawer.getSectionsToRender().map(function(s){ return s.id; }).join(',');
  fetch(window.location.pathname + '?sections=' + encodeURIComponent(ids), {cache:'no-store'})
    .then(function(r){ return r.json(); })
    .then(function(sections){ drawer.renderContents({ sections: sections }); })
    .catch(function(){ window.location.href = '/cart'; });
}

window.klAddToCart = function(){
  if(!selectedSize) return;
  var tot = matTot();
  if(tot < selectedSize.qty) return;

  var cta  = document.getElementById('kl-cta');
  var cta2 = document.getElementById('kl-cta-2');
  var errEl = document.getElementById('kl-err-inline');

  var chosen = matCards.filter(function(c){ return (matQtys[c.dataset.id] || 0) > 0; });
  var props  = {};
  chosen.forEach(function(c){
    var q = matQtys[c.dataset.id];
    props['Килимок ' + c.dataset.name] = q + ' ' + decKyl(q);
  });

  cta.disabled  = true;
  cta2.disabled = true;
  cta.innerHTML  = '<span class="kl-spinner"></span>Додаємо...';
  cta2.innerHTML = '<span class="kl-spinner"></span>Додаємо...';
  errEl.classList.remove('show');
  document.getElementById('kl-toast').classList.remove('show');

  /* Будуємо список айтемів: спочатку бандл, потім кожен горщик */
  var bundleItem = {id: parseInt(selectedSize.vid), quantity: 1, properties: props};
  var potList = [];
  Object.keys(potQtys).forEach(function(k){
    if(potQtys[k] > 0) potList.push({id: parseInt(POTS[k].vid), quantity: potQtys[k], _name: POTS[k].name});
  });

  /* Послідовно: бандл → sync → горщик1 → sync → горщик2 → sync → редірект.
     Якщо бандл падає — стоп.
     Якщо горщик падає — показати тост, але редіректнути (бандл уже у кошику). */
  var failedPots = [];

  klPostOne(bundleItem)
    .then(klSync)
    .then(function(){
      /* Додаємо горщики по одному з паузами між ними */
      return potList.reduce(function(chain, item){
        return chain
          .then(function(){
            return klPostOne(item).then(klSync).catch(function(err){
              console.error('[kl] failed to add pot', item, err);
              failedPots.push(item._name + ' (' + err.message + ')');
              /* Ковтаємо помилку — продовжуємо */
              return null;
            });
          });
      }, Promise.resolve());
    })
    .then(function(){
      return klSync();
    })
    .then(function(cart){
      /* Оновити бабл лічильника товарів */
      document.querySelectorAll('.cart-count-bubble').forEach(function(b){
        var sp = b.querySelector('span:not(.visually-hidden)');
        if(sp) sp.textContent = cart.item_count;
      });

      if(failedPots.length){
        klShowToast('Бандл додано, але не вдалось додати горщик: ' + failedPots.join(', '), true);
      }
      /* Відкриваємо drawer кошика (як на решті сайту), а не редіректимо на /cart */
      renderSummary();
      klOpenDrawer();
    })
    .catch(function(err){
      /* Сюди потрапляємо тільки якщо БАНДЛ не додався */
      console.error('[kl] bundle add failed:', err);
      var msg = 'Не вдалось додати: ' + (err && err.message ? err.message : 'спробуйте ще раз');
      errEl.textContent = msg;
      errEl.classList.add('show');
      klShowToast(msg, true);
      cta.disabled = false; cta2.disabled = false;
      renderSummary();
    });
};

/* ---------- Accordion ---------- */
window.klToggleAcc = function(btn){
  btn.closest('.kl-acc-item').classList.toggle('open');
};

/* ---------- OOS init для горщиків ---------- */
function klInitOOS(){
  ['std','cer','dbl'].forEach(function(k){
    var card = document.getElementById('kl-pot-' + k);
    if(!card || card.dataset.oos !== 'true') return;

    /* Скидаємо стейт + блокуємо взаємодію */
    potQtys[k] = 0;
    card.classList.add('oos');
    card.removeAttribute('onclick');

    /* Бейдж «Нема в наявності» зверху-зліва на фото */
    var imgWrap = card.querySelector('.kl-pot-img');
    if(imgWrap && !imgWrap.querySelector('.kl-pot-oos-badge')){
      var badge = document.createElement('span');
      badge.className = 'kl-pot-oos-badge';
      badge.textContent = '⚠️ Нема в наявності';
      imgWrap.appendChild(badge);
    }

    /* Заміна лічильника на кнопку «Передзамовлення» */
    var cntWrap = card.querySelector('.kl-pot-cnt-wrap');
    if(cntWrap){
      var url = (card.dataset.preorderUrl || '').trim();
      var node;
      if(url){
        node = document.createElement('a');
        node.href = url;
        node.className = 'kl-pot-preorder';
        node.target = '_self';
      } else {
        node = document.createElement('div');
        node.className = 'kl-pot-preorder kl-static';
      }
      node.textContent = 'Передзамовлення, тиць тут :)';
      node.addEventListener('click', function(e){ e.stopPropagation(); });
      cntWrap.parentNode.replaceChild(node, cntWrap);
    }
  });
}

/* ---------- Init ---------- */
loadState();
klInitOOS();
renderMats();
renderSummary();
renderPots();

/* Fix for Browser Back Button Cache (BFCache) */
window.addEventListener('pageshow', function(event) {
  if (event.persisted) {
    renderSummary();
  }
});

/* ── Accessible pot cards ──────────────────────────────────────────────────
   Pot cards carry role="button" tabindex="0" in the markup but were mouse-only.
   1) Enter/Space activates the card (reuses the existing onclick → klTogglePot).
   2) A MutationObserver mirrors the .sel selected-state into aria-pressed, so the
      state is announced no matter which code path (click, counters, OOS) changes it. */
(function(){
  var cards = document.querySelectorAll('.kl-pot-card');
  if (!cards.length) return;
  function syncAria(card){
    card.setAttribute('aria-pressed', card.classList.contains('sel') ? 'true' : 'false');
  }
  cards.forEach(function(card){
    syncAria(card);
    new MutationObserver(function(){ syncAria(card); })
      .observe(card, { attributes: true, attributeFilter: ['class'] });
  });
  document.addEventListener('keydown', function(e){
    if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
    var card = e.target.closest ? e.target.closest('.kl-pot-card') : null;
    if (!card) return;
    e.preventDefault();
    card.click();
  });
})();

})();
